export const aiPhotoGenerationFolderName = 'Библиотека\u00A0генераций';

export const aiPhotoGenerationFolderId = `/${aiPhotoGenerationFolderName}`;

export enum aiPhotoGenerationLoaderTextVariants {
    variant1 = 'Точим цифровой карандашик',
    variant2 = 'Делаем набросок',
    variant3 = 'Двигаем пиксели',
    variant4 = 'Смешиваем краски',
    variant5 = 'Пишем картину',
}

export const AI_PHOTO_GENERATION_PAY_SOURCE = 'mail_web_image_gen';

export const MAX_PROMPT_DWH_SYMBOLS = 256;

export const HOT_KEY_SCOPE_NAME = 'ai-photo-generation';
